
export const LOAD_ALL_PINCODE = "LOAD_ALL_PINCODE"
export const EMPTY_LOCAL_SORE = "EMPTY_LOCAL_SORE"
export const GET_HEALTH_QUOTES = "GET_HEALTH_QUOTES"
export const HEALTH_QUOTES_STORE = "HEALTH_QUOTES_STORE"
export const GET_ALL_HEALTH_RELATION = "GET_ALL_HEALTH_RELATION"
export const GET_ALL_MEMBER_OCCUPATION = "GET_ALL_MEMBER_OCCUPATION"
export const GET_ALL_HEALTH_STATE = "GET_ALL_HEALTH_STATE"
export const GET_ALL_HEALTH_CITY = "GET_ALL_HEALTH_CITY"
export const POLICY_DETAILS_ADDED = "POLICY_DETAILS_ADDED"
export const SELECTED_PRODUCT_ADDED = "SELECTED_PRODUCT_ADDED"
export const FAMILY_STORE = "FAMILY_STORE"
export const ADDONS_STORE = "ADDONS_STORE"
export const NIVABHUPA_QUOTES_VALUE = "NIVABHUPA_QUOTES_VALUE"
export const EMPTY_NIVABHUPA_DATA = "EMPTY_NIVABHUPA_DATA"
export const SELECTED_ADDONS = "SELECTED_ADDONS"
export const ACTIVE_INSURER_LIST = "ACTIVE_INSURER_LIST"
export const NOT_GET_QUOTES = "NOT_GET_QUOTES"
export const RESET_GET_QUOTES = "RESET_GET_QUOTES"
export const HEALTH_QUOTES_RESP = "HEALTH_QUOTES_RESP"

export const PROPOSER_DETAILS = "PROPOSER_DETAILS"
export const INSURED_MEMBER = "INSURED_MEMBER"
export const COMMUNICATION_ADDRES = "COMMUNICATION_ADDRES"
export const REFUND_POLICY_DETAILS = "REFUND_POLICY_DETAILS"
export const MEDICAL_HISTORY = "MEDICAL_HISTORY"
export const GET_ALL_MEDICAL = "GET_ALL_MEDICAL"
export const GET_HEALTH_PROPOSAL = "GET_HEALTH_PROPOSAL"

export const KYC_RESP_STORE = "KYC_RESP_STORE"

export const SBI_KYC_RES = "SBI_KYC_RES"
export const CARE_KYC_RES = "CARE_KYC_RES"
export const HDFC_KYC_RES = "HDFC_KYC_RES"
export const ICICI_KYC_RES = "ICICI_KYC_RES"
export const GENERIC_KYC_RESP = "GENERIC_KYC_RESP"
export const NIVABHUPA_KYC_RESPONSE_STORE = "NIVABHUPA_KYC_RESPONSE_STORE"

export const COVERED_BENEFITS = "COVERED_BENEFITS"
export const GET_NOMINEE_RELATIONS_INSURERID = "GET_NOMINEE_RELATIONS_INSURERID"
export const GET_ALL_HEALTH_OCCUPATIONS = "GET_ALL_HEALTH_OCCUPATIONS"
export const GET_ALL_GENRIC_OCCUPATIONS = "GET_ALL_GENRIC_OCCUPATIONS"
export const GET_ALL_MEMBER_EDUCATION = "GET_ALL_MEMBER_EDUCATION"
export const PROPOSAL_ALL_DATA_EMPTY = "PROPOSAL_ALL_DATA_EMPTY"
export const PROPOSAL_LOCAL_SORE = "PROPOSAL_LOCAL_SORE"
export const STATE_CHANGE_EMPTY_CITY = "STATE_CHANGE_EMPTY_CITY"
